import React from 'react';
import Notification from '../../Notification';
import { injectIntl, FormattedMessage } from 'react-intl';
import Row from '../../tag/Row';
import Span from '../../tag/Span';
import Urls from '../../../definitions/Urls';
import { hasLinkkipalveluLinkValue } from '../../../utils/TimelineUtils';

import { withRouter } from 'react-router-dom';
import OTButton from '../../tag/OTButton';

import Logger from '../../../utils/Logger';
import { connect } from 'react-redux';

const { id: module_id } = module;
const logger = new Logger(module_id);

const NoRescheduleTimesAvailableNotification = ({
  history,
  clinic,
  intl,
  linkkipalvelu,
}) => {
  // tries to find clinic message and link, if not found then fallback of default message is not found.
  const resolveClinicMessageOrDefault = (clinic, intl) => {
    let defaultMessage = `${module_id}.message.default`;
    let clinicMessage = `${module_id}.message.${clinic}`;

    //if clinic has a link and a text, return clinic message
    if (getClinicLink(clinic) !== null && intl.messages[clinicMessage]) {
      return clinicMessage;
    }

    return defaultMessage;
  };

  const getClinicLink = (clinic) => {
    //Use these hardcoded links, if we want to use them instead of links from Linkkipalvelu.
    //Remove link from the list if Linkkipalvelu-link should be used.
    let oldLinks = new Map([
      [
        'HPVA',
        'http://www.tays.fi/fi-FI/Toimipaikat/Tays_Hatanpaa/Hoitoyksikot/Vatsakeskus',
      ],
      [
        'PNE',
        'http://tays.fi/fi-FI/Toimipaikat/Tays_Keskussairaala/Hoitoyksikot/Neurokirurgian_poliklinikka',
      ],
    ]);

    //link from oldLinks-list
    if (oldLinks.get(clinic)) {
      return oldLinks.get(clinic);
    }

    //link from Linkkipalvelu
    if (hasLinkkipalveluLinkValue(getLinkValue(clinic))) {
      return getLinkValue(clinic);
    }

    //link not found, show default message
    return null;
  };

  const getLinkValue = (departmentAbbr) => {
    return (
      linkkipalvelu.Toimipistetiedot &&
      linkkipalvelu.Toimipistetiedot[departmentAbbr]
    );
  };

  let message = resolveClinicMessageOrDefault(clinic, intl);

  return (
    <Notification>
      <Row>
        <Span>
          <span className="ot-notification__header">
            <FormattedMessage id={`${module_id}.title`} />
          </span>
        </Span>
      </Row>
      <Row>
        <Span>
          <FormattedMessage
            id={message}
            values={{
              hpvaLink: (chunks) => (
                <a target="_blank" href={getClinicLink(clinic)}>
                  {chunks}
                </a>
              ),
              huatLink: (chunks) => (
                <a target="_blank" href={getClinicLink(clinic)}>
                  {chunks}
                </a>
              ),
              pneLink: (chunks) => (
                <a target="_blank" href={getClinicLink(clinic)}>
                  {chunks}
                </a>
              ),
            }}
          />
        </Span>
      </Row>
      <Row>
        <Span>
          <br />
          <OTButton
            onClick={() => {
              history.push(Urls.frontPageHistory);
            }}
          >
            <FormattedMessage id={`${module_id}.go.back`} />
          </OTButton>
        </Span>
      </Row>
    </Notification>
  );
};

const mapStateToProps = (state) => {
  return {
    linkkipalvelu: state.linkkipalvelu,
  };
};

export default injectIntl(
  withRouter(connect(mapStateToProps)(NoRescheduleTimesAvailableNotification))
);
